import React from 'react';
import { Target, Heart } from 'lucide-react';
import { visionMission } from '../data/mock';

const VisionMission = () => {
  return (
    <section id="vision" className="py-20 bg-gradient-to-br from-orange-50 via-yellow-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Vision */}
          <div className="bg-white rounded-2xl shadow-xl p-8 transform hover:scale-105 transition-transform duration-300 border-t-4 border-blue-600">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Target className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                {visionMission.vision.title}
              </h2>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              {visionMission.vision.content}
            </p>
            <div className="mt-8 p-4 bg-blue-50 rounded-lg border-l-4 border-blue-600">
              <p className="text-2xl font-bold text-blue-600">Prabuddha Bharath</p>
              <p className="text-sm text-gray-600 mt-1">Enlightened India - Our Ultimate Goal</p>
            </div>
          </div>

          {/* Mission */}
          <div className="bg-white rounded-2xl shadow-xl p-8 transform hover:scale-105 transition-transform duration-300 border-t-4 border-orange-600">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
                <Heart className="w-8 h-8 text-orange-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                {visionMission.mission.title}
              </h2>
            </div>
            <ul className="space-y-4">
              {visionMission.mission.activities.map((activity, index) => (
                <li key={index} className="flex items-start gap-3 group">
                  <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-orange-600 transition-colors">
                    <span className="text-sm font-bold text-orange-600 group-hover:text-white transition-colors">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-gray-700 leading-relaxed group-hover:text-gray-900 transition-colors">
                    {activity}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
          <div className="bg-white p-6 rounded-xl shadow-lg text-center transform hover:-translate-y-1 transition-transform">
            <p className="text-4xl font-bold text-blue-600 mb-2">12</p>
            <p className="text-gray-600">Years of Service</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg text-center transform hover:-translate-y-1 transition-transform">
            <p className="text-4xl font-bold text-yellow-600 mb-2">10,000+</p>
            <p className="text-gray-600">Volunteers</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg text-center transform hover:-translate-y-1 transition-transform">
            <p className="text-4xl font-bold text-red-600 mb-2">100,000+</p>
            <p className="text-gray-600">Lives Impacted</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg text-center transform hover:-translate-y-1 transition-transform">
            <p className="text-4xl font-bold text-orange-600 mb-2">200+</p>
            <p className="text-gray-600">Events Organized</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
